import { PlusInSquareIcon } from "assets/icons";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useGetVariantsByIds } from "modules/products";
import { useMemo } from "react";
import { Button, Pagination } from "ui";

import { AdProductsTable } from "../../components";
import { AdProductModal } from "../../features";
import { variantSummaryToPreview } from "../../helpers/variantAdapters";
import { useAdProductsList } from "../../hooks";
import { VariantPreview } from "../../whatsappAdProducts.types";

import styles from "./AdProducts.module.scss";

const AdProducts = () => {
  const {
    value: isCreateModalOpen,
    setTrue: openCreateModal,
    setFalse: closeCreateModal
  } = useBoolean();

  const { adProducts, totalItems, page, setPage, isLoading } =
    useAdProductsList();

  const variantIds = useMemo(
    () =>
      Array.from(new Set(adProducts.flatMap((ap) => ap.productVariantIds))),
    [adProducts]
  );

  const { variants } = useGetVariantsByIds(variantIds);

  const variantsById = useMemo(() => {
    const map = new Map<string, VariantPreview>();
    for (const v of variants) {
      map.set(v.id, variantSummaryToPreview(v));
    }
    return map;
  }, [variants]);

  return (
    <ContentLayout
      title={t("WhatsApp Ad Mappings")}
      action={
        <Button onClick={openCreateModal} icon={<PlusInSquareIcon />}>
          {t("New Ad Mapping")}
        </Button>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <AdProductsTable
          adProducts={adProducts}
          variantsById={variantsById}
          isLoading={isLoading}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      {isCreateModalOpen ? (
        <AdProductModal isOpen onClose={closeCreateModal} />
      ) : null}
    </ContentLayout>
  );
};

export default AdProducts;
